import {Route, Switch} from "react-router-dom";
import OfferProducts from "./OfferProducts";
import OfferProductDetails from "./OfferProductDetails";
import OfferProductView from "./OfferProductView";

const App = ({match}) => (
    <Switch>
      <Route exact path={`${match.url}`} component={OfferProducts}/>
      <Route path={`${match.url}/view/:id?`} component={OfferProductView}/>
      <Route path={`${match.url}/add-edit/:id?`} component={OfferProductDetails}/>


    </Switch>
);

export default App;